class ToggleQuestion {
  protected boxes?: NodeListOf<Element>;

  constructor(className: String) {
    this.boxes = document.querySelectorAll(`${className}`);

    if (this.boxes) {
      this._init();
    }
  }

  private _init(): void {
    this.boxes?.forEach((box) => {
      box.addEventListener('click', (event) => {
        const targetElement = event.currentTarget as HTMLDivElement;
        const questionElement = targetElement?.children[0]?.children[0];
        const responseElement = targetElement?.children[1];
        const iconElement = targetElement?.children[0].children[1];

        if (responseElement) {
          this._expandElement(
            responseElement,
            'faq__response--open',
            iconElement ?? null,
            questionElement ?? null
          );
        }
      });
    });
  }

  private _expandElement(element, className, iconElement?, questionElement?) {
    element.style.height = '';
    questionElement.style.paddingBottom = '';
    // element.style.paddingTop = '';
    element.style.transition = 'none';
    // element.style.transition = 'padding-top 0.4s ease-in-out';

    const startHeight = window.getComputedStyle(element).height;
    // const startPaddingTop = window.getComputedStyle(element).paddingTop;
    const startPaddingBottom = window.getComputedStyle(element).paddingBottom;

    element.classList.toggle(className);
    questionElement.classList.toggle('faq__content--open');

    const height = window.getComputedStyle(element).height;

    element.style.height = startHeight;
    // element.style.paddingTop = '10px';

    if (iconElement != null) {
      iconElement.classList.toggle('faq__icon--less');
    }

    requestAnimationFrame(() => {
      // console.log('requestAnimationFrame() 1');
      element.style.transition = '';

      // if (startPaddingTop == '10px') {
      //   element.style.paddingTop = '0px';
      // }

      requestAnimationFrame(() => {
        // console.log('requestAnimationFrame() 2');
        element.style.height = height;
      });
    });

    element.addEventListener('transitionend', () => {
      // console.log('transitionEnd()');
      element.style.height = '';
      // element.style.paddingTop = '';
      element.removeEventListener('transitionend', this);
    });
  }
}

new ToggleQuestion('.faq__box');
